/* eslint-disable */
import { propsDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import ResortsRepository from "@/js/common/Domain/Repository/Resorts";
import ResortView from './ResortView';

import './filter-resorts.scss';
import _ from 'underscore';

@viewModelDecorator({
    defaults: {
        otherResortsVisible: false,
        otherResortsAmount: 0,
    },
})

@propsDecorator({
    $allResortsCheckbox: null,
    $resortsListContainer: null,
    $resortsListPopular: null,
    $resortsListOther: null,
    $selectedResortsAmount: null,
    parentViewModel: null,
    resortsCollectionView: [],
    currentSelectedCountry: null,
    currentSelectedResorts: [],
    selectedResortsCollection: new ResortsRepository(),
    events:{
        'click .resortsFilter__resortsListCancel': 'revertResorts',
        'click .resortsFilter__resortsListApply': 'applyResorts',
        'click .resortsFilter__toggleOtherResorts': 'otherResortsToggle',
        'click' : 'toggleList'
    },
    bindings: {
        '.resortsFilter_otherResorts': 'toggle:otherResortsVisible',
        '.resortsFilter__otherResortsVisible': 'toggle:otherResortsVisible',
        '.resortsFilter__otherResortsHidden': 'toggle:not(otherResortsVisible)',
        '.resortsFilter__toggleOtherResorts': 'toggle:otherResortsAmount'
    },
})

export default class extends Backbone.Epoxy.View {
    otherResortsToggle() {
        this.viewModel.set('otherResortsVisible', !this.viewModel.get('otherResortsVisible'));
    }

    toggleList(event) {
        const $eventTarget = $(event.target);
        if ($eventTarget.is(this.$el) || $eventTarget.is(this.$selectedResortsAmount)) {
            if (this.$resortsListContainer.is(':visible')) {
                this.hideList();
                return;
            }

            this.showList();
        }
    }
   
    revertResorts() {
        const searchData = this.parentViewModel.get('searchData');
        const selectedResorts = searchData ? searchData.get('resorts') : null;

        if (selectedResorts) {
            this.selectedResortsCollection.reset(selectedResorts.models, { silent: true });
            this.selectedResortsCollection.trigger('reset');
        }

        this.hideList();
    }

    applyResorts() {
        this.parent.model.get('resorts').set('model', this.selectedResortsCollection.clone());
        this.parent.formSubmit({goToHotelPage:false});
        this.hideList();
    }

    initListContainer() {
        this.$resortsListContainer = $('.resortsFilter__resortsListContainer', this.$el);
    }

    initListPopular() {
        this.$resortsListPopular = $('.resortsFilter_popularResorts', this.$el);
    }

    initListOther() {
        this.$resortsListOther = $('.resortsFilter_otherResorts', this.$el);
    }

    initResortsAmount() {
        this.$selectedResortsAmount = $('.resortsFilter__resortsSelected', this.$el);
    }

    hideList() {
        this.parentViewModel.set('blurToursColumn', false);
        this.$el.removeClass('resortsFilter_opened');
    }

    showList() {
        this.parentViewModel.set('blurToursColumn', true);
        this.$el.addClass('resortsFilter_opened');
    }

    initDOMEvents() {
        $(document).on('click', (event) => {
            if (!this.$el || !this.$el.length){
                return;
            }

            if (!($.contains(this.$el.get(0), event.target) || this.$el.is(event.target))) {
                this.revertResorts();
            }
        });
    }

    allResortsSelected() {
        this.selectedResortsCollection.reset([]);
    }

    renderResortsList(countryResortsRaw) {
        const $resortsPopular = [];
        const $resortsOther = [];
        const $resortsListPopular = $('<ul class="resortsFilter__resortsListCollection"></ul>');
        const $resortsListOther = $('<ul class="resortsFilter__resortsListCollection"></ul>');
        
        const $resortListAllItem = $('<li><label class="checkbox">\n\t<input type="checkbox">\n\t<div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n\t<b>Все курорты</b>\n</label></li>');

        const countryResortsSorted = countryResortsRaw.sortBy((resort) => resort.get('name'));
        const countryResorts = _.filter(countryResortsSorted, (resort) => {
            return resort.get('atFiltering') || (this.currentSelectedResorts && _.indexOf(this.currentSelectedResorts.models, resort) !== -1);
        });
        const popularResorts = _.filter(countryResorts, (resort) => resort.get('isPopular'));
        const otherResorts = _.filter(countryResorts, (resort) => !resort.get('isPopular'));

        this.viewModel.set('otherResortsAmount', otherResorts.length);

        this.resortsCollectionView = [];

        $resortsPopular.push('<div class="resortsFilter__resortsListCategoryLabel">Популярные курорты</div>');
        $resortsListPopular.append($resortListAllItem);
        this.$allResortsCheckbox = $('input', $resortListAllItem);
        this.$allResortsCheckbox.on('click', $.proxy(this.allResortsSelected, this));

        _.each(popularResorts, (resortModel) => {
            const resort = new ResortView({
                model: resortModel,
                parent: this,
                selectedResortsCollection: this.selectedResortsCollection
            });

            this.resortsCollectionView.push(resort);
            $resortsListPopular.append(resort.$el);
        });

        $resortsPopular.push($resortsListPopular);

        if (otherResorts && otherResorts.length) {
            $resortsOther.push('<div class="resortsFilter__resortsListCategoryLabel">Остальные курорты</div>');
            _.each(otherResorts, (resortModel) => {
                const resort = new ResortView({
                    model: resortModel,
                    parent:this,
                    selectedResortsCollection: this.selectedResortsCollection
                });

                this.resortsCollectionView.push(resort);
                $resortsListOther.append(resort.$el);
            });
            $resortsOther.push($resortsListOther);
        }

        this.$resortsListPopular.html($resortsPopular);
        this.$resortsListOther.html($resortsOther);
    }

    updateResortsList(searchData) {
        const searchDataCountries = searchData
            ? searchData.get('countries')
            : null;

        const searchDataCountry = searchDataCountries
            ? searchDataCountries.at(0)
            : null;
        
        const selectedResorts = searchData
            ? searchData.get('resorts')
            : null;
        
        const countryResorts = searchDataCountry
            ? searchDataCountry.get('resorts')
            : null;

        const intersectionLength = selectedResorts && this.currentSelectedResorts
            ? _.intersection(selectedResorts.models, this.currentSelectedResorts.models).length
            : false;

        if ((countryResorts && searchDataCountry && searchDataCountry !== this.currentSelectedCountry) ||
            (intersectionLength !== false && (intersectionLength !== this.currentSelectedResorts.length || intersectionLength !== selectedResorts.length))) {
            this.currentSelectedCountry = searchDataCountry;
            this.currentSelectedResorts = selectedResorts;
            this.renderResortsList(countryResorts);
        }

        if (selectedResorts) {
            this.selectedResortsCollection.reset(selectedResorts.models);
            return;
        }

        this.selectedResortsCollection.reset([]);
    }

    updateLabel(selectedResorts) {
        if (selectedResorts?.length) {
            if (selectedResorts.length === 1) {
                this.$selectedResortsAmount.text(selectedResorts.at(0).get('name'));
                return;
            
            }

            const firstEnding = selectedResorts.length.wordEnding(';о;о');
            const secondEnding = selectedResorts.length.wordEnding(';а;ов');

            this.$selectedResortsAmount
                .text(`Выбран${firstEnding} ${selectedResorts.length} курорт${secondEnding}`);

            return;
        }

        this.$selectedResortsAmount.text('Выбрать курорты из списка');
    }

    modelChanged(event, model) {
        if (model === null) {
            this.$el.addClass('disabled');
            return;
        }

        this.$el.removeClass('disabled');
        this.updateResortsList(model);
    }

    selectedResortsCollectionChanged() {
        const selectedResortsCollection = this.selectedResortsCollection?.length
            ? this.selectedResortsCollection
            : [];

        if (this.$allResortsCheckbox) {
            this.$allResortsCheckbox.prop('checked', !selectedResortsCollection.length)
        }

        _.each(this.resortsCollectionView, (resort) => {
            const currentCountryId = resort.model.get('id');

            if (selectedResortsCollection.length && selectedResortsCollection.findWhere({ id: currentCountryId })) {
                resort.$countryCheckbox.prop('checked', true);
                return;
            }

            resort.$countryCheckbox.prop('checked', false);
        });

        this.updateLabel(selectedResortsCollection);
    }

    populateResortsForStatic(searchData) {
        this.$el.removeClass('disabled');
        this.updateResortsList(searchData);
        this.updateLabel(searchData);
    }

    initModelEvents() {
        this.parentViewModel.on('change:searchData', $.proxy(this.modelChanged, this));
        this.selectedResortsCollection.on('reset add remove', $.proxy(this.selectedResortsCollectionChanged, this));
    }

    initialize(options) {
        this.parentViewModel = options.viewModel;
        this.parent = options.parent;

        this.initListContainer();
        this.initListPopular();
        this.initListOther();
        this.initResortsAmount();

        this.initDOMEvents();
        this.initModelEvents();
    }
}
